import * as React from "react"
import BaseModal  from "./base-modal"

export default class ImageModal extends BaseModal<ImageModalProps> {
	render() {
		const alt                = this.props.alt
		const isActive           = this.props.active
		const onClickCloseButton = this.props.onClickCloseButton
		const src                = this.props.src

		return (
			<div className={`modal ${isActive ? "is-active" : ""}`}>
				<div className="modal-background" onClick={onClickCloseButton} />
				<div className="modal-content">
					<p className="image"><img src={src} alt={alt} /></p>
				</div>
				<button aria-label="close" className="modal-close" onClick={onClickCloseButton} type="button" />
			</div>
		)
	}
}

export interface ImageModalProps {
	src: string,
	alt: string
}


// WEBPACK FOOTER //
// ./src/component/modal/image-modal.tsx